import { render } from "./v-employee-details.vue?vue&type=template&id=13d4172e"
import script from "./v-employee-details.vue?vue&type=script&lang=js"
export * from "./v-employee-details.vue?vue&type=script&lang=js"

import "./v-employee-details.vue?vue&type=style&index=0&id=13d4172e&lang=css"

import exportComponent from "/builds/simplecrm/simplecrmfront/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__